import React from "react";
import { useNavigate } from "react-router-dom";

const Footer = () => {
  const navigate = useNavigate();

  const handleCategorySearch = (category) => {
    navigate(`/search?q=${category}`);
  };

  return (
    <footer>
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>Ceekay Enterprise</h3>
            <p>
              Your trusted partner in import of industrial chemicals since 1992.
              Quality products, competitive prices, and reliable service.
            </p>
          </div>
          <div className="footer-section">
            <h3>Quick Links</h3>
            <ul>
              <li>
                <button onClick={() => navigate("/")}>Home</button>
              </li>
              <li>
                <button onClick={() => navigate("/products")}>Products</button>
              </li>
              <li>
                <button onClick={() => navigate("/about")}>About Us</button>
              </li>
              <li>
                <button onClick={() => navigate("/contact")}>Contact</button>
              </li>
              <li>
                <button onClick={() => navigate("/blog")}>Blog</button>
              </li>
            </ul>
          </div>
          <div className="footer-section">
            <h3>Product Categories</h3>
            <ul>
              <li>
                <button onClick={() => handleCategorySearch("industrial")}>
                  Industrial Chemicals
                </button>
              </li>
              <li>
                <button onClick={() => handleCategorySearch("compound")}>
                  Chemical Compounds
                </button>
              </li>
              <li>
                <button onClick={() => handleCategorySearch("potassium")}>
                  Potassium Products
                </button>
              </li>
              <li>
                <button onClick={() => handleCategorySearch("salts")}>
                  Specialty Salts
                </button>
              </li>
            </ul>
          </div>
          <div className="footer-section">
            <h3>Contact Info</h3>
            <ul>
              <li>📍 Mumbai, Maharashtra</li>
              <li>📞 +91-9322629818</li>
              <li>📧 ceekayent@yahoo.com</li>
              <li>🌐 GST: 27AAAPP8389F1ZA</li>
            </ul>
          </div>
        </div>
        <div className="footer-bottom">
          <p>
            &copy; 2025 Ceekay Enterprise. All rights reserved. | GST:
            27AAAPP8389F1ZA
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
